import React from "react";
import styles from "./PricingCard.module.css";
import tkLogo from "../../assets/tk.svg";
import { ORDER_LINK } from "../../constant/links";
import { BsCheck } from "react-icons/bs";
import { Link } from "react-router-dom";

const PricingCard = ({ name, image, price, unit, text, data, landing, unavailable }) => {
  return (
    <div className={styles.card}>
      <div className="">
        <h3 className={styles.crd_title}>{name}{unavailable && " (Unavailable)"}</h3>
        <div className="d-flex justify-content-center">
          <img src={image} alt={name} className={styles.price_img} />
        </div>
        <div className="d-flex justify-content-center align-items-center pb-3">
          <span>Starts from</span>
          <img src={tkLogo} alt="taka" className={styles.takaLogo} />
          <span className={styles.price_amount}>{price}</span>
          <span className={styles.price_unit}>{unit}</span>
        </div>
        {/* <span className={`d-block ${styles.build_time}`}>{text}</span> */}
        <div className="pb-3">
          {data.map((item, i) => (
            <div key={i} className="d-flex align-items-center px-2">
              <BsCheck size={24} color="rgba(86, 204, 242, 1)" className="" />
              <span
                className={styles.list_item}
                style={{ fontSize: landing === true ? 18 : 16 }}
              >
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>
      {!unavailable && 
      <div className="">
        <a
          //  to="/order"
          href={ORDER_LINK}
          target={"_blank"}
          rel="noopener noreferrer"
          className={`btn btn-block ${styles.btn_order}`}
        >
          Order Now 
        </a>
      </div>}
    </div>
  );
};

export default PricingCard;
